export function addEventListener(handler) {
  window.addEventListener('message', handler, false)
}
